<template>
    <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
    name: 'master-customerSet',
    components: {
        PageTable,
    },
}
</script>
